import { get } from '../../api';

export const getLogs = (idConfiguracao, page) => {
  return get(`/api/conectores/logs/${idConfiguracao}?page=${page}`);
};

export const getLog = (idConfiguracao, id, page) => {
  return get(`/api/conectores/log/${idConfiguracao}/${id}?page=${page}`);
};
